/*
 * GA4 form-success events for James Crossing (.ca and .co share this theme).
 *
 * Measurement ID G-LE6X1DCRLB is already installed by the Google & YouTube
 * app web pixel (it injects gtag/dataLayer on the storefront). This file
 * never calls gtag('config') or gtag('js') and does not load gtag.js.
 *
 * Events fire only after a confirmed successful submit. Payloads are
 * page_location and form_name only — no name, email, phone, or company.
 */
(function () {
  'use strict';

  var ALLOWED_EVENTS = {
    trade_application_submit: true,
    newsletter_signup: true,
    design_consultation_submit: true,
    general_inquiry_submit: true,
  };

  var ALLOWED_FORM_NAMES = {
    'Designers trade application': true,
    'Footer newsletter': true,
    'Popup newsletter': true,
    Newsletter: true,
    'General inquiries': true,
    'Design consultation': true,
  };

  var PAGE_GUARDS = {
    trade_application_submit: /\/pages\/trade-program\/?$/,
    general_inquiry_submit: /\/pages\/contact\/?$/,
    design_consultation_submit: /\/pages\/design-consult\/?$/,
  };

  var sent = {};

  function pageLocation() {
    try {
      return window.location.href;
    } catch (error) {
      return '';
    }
  }

  function hashMatches(formId) {
    if (!formId) return true;
    var hash = '';
    try {
      hash = decodeURIComponent((window.location.hash || '').replace(/^#/, ''));
    } catch (error) {
      hash = (window.location.hash || '').replace(/^#/, '');
    }
    if (!hash) return true;
    return hash === String(formId);
  }

  function onGuardedPage(eventName) {
    var guard = PAGE_GUARDS[eventName];
    if (!guard) return true;
    return guard.test(window.location.pathname);
  }

  function send(eventName, formName, formId) {
    if (!ALLOWED_EVENTS[eventName] || !ALLOWED_FORM_NAMES[formName]) return;
    if (!onGuardedPage(eventName)) return;
    if (!hashMatches(formId)) return;

    var key = eventName + '\n' + formName;
    if (sent[key]) return;
    sent[key] = true;

    var params = {
      page_location: pageLocation(),
      form_name: formName,
    };

    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      return;
    }

    // Queue a gtag command. The Google & YouTube snippet keeps this array
    // (dataLayer = dataLayer || []) and gtag.js replays it. No config call.
    (function () {
      window.dataLayer.push(arguments);
    })('event', eventName, params);
  }

  window.jcGa4Event = function (eventName, formName, formId) {
    send(eventName, formName, formId);
  };

  var queued = window.jcGa4Queue || [];
  window.jcGa4Queue = [];
  queued.forEach(function (item) {
    if (!item) return;
    send(item.eventName, item.formName, item.formId);
  });

  // Later server-rendered success snippets can still run after this file
  // if a section is re-rendered. Keep draining anything pushed afterward.
  window.jcGa4Queue.push = function () {
    Array.prototype.forEach.call(arguments, function (item) {
      if (!item) return;
      send(item.eventName, item.formName, item.formId);
    });
    return window.jcGa4Queue.length;
  };

  function tradeFormConfirmed(shadow) {
    var app = shadow.getElementById('app-embed');
    var step = app && app.getAttribute('data-current-step');
    if (step === 'success') return true;
    if (step === 'form' || step === 'tease' || step === 'error') return false;
    return !!shadow.querySelector('[data-testid="banner-success"]');
  }

  function watchShadow(shadow) {
    if (!shadow || shadow.__jcGa4Trade) return;
    shadow.__jcGa4Trade = true;

    var report = function () {
      if (!tradeFormConfirmed(shadow)) return;
      if (!onGuardedPage('trade_application_submit')) return;
      send('trade_application_submit', 'Designers trade application');
      observer.disconnect();
    };

    var observer = new MutationObserver(report);

    observer.observe(shadow, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-current-step'],
    });

    report();
  }

  function embedsIn(root) {
    var named = root.querySelectorAll(
      'shopify-forms-embed, shopify-forms-embed-dev, shopify-forms-embed-staging, shopify-forms-embed-staging-2, shopify-forms-embed-staging-3, shopify-forms-embed-staging-4',
    );
    if (named.length) return named;
    return Array.prototype.filter.call(root.querySelectorAll('*'), function (element) {
      return !!element.shadowRoot;
    });
  }

  function watchRoot(root) {
    if (!root || root.__jcGa4TradeRoot) return;
    root.__jcGa4TradeRoot = true;

    var scan = function () {
      Array.prototype.forEach.call(embedsIn(root), function (embed) {
        watchShadow(embed.shadowRoot);
      });
    };

    scan();
    new MutationObserver(scan).observe(root, { childList: true, subtree: true });
  }

  function watchTradeForm() {
    var formId = String(window.jcGa4TradeFormId || '');
    if (!/^\d+$/.test(formId)) return;
    if (!/\/pages\/trade-program\/?$/.test(window.location.pathname)) return;

    var selector = '[data-forms-id="forms-root-' + formId + '"]';

    var bind = function () {
      var roots = document.querySelectorAll(selector);
      if (!roots.length) return false;
      Array.prototype.forEach.call(roots, watchRoot);
      return true;
    };

    if (bind()) return;

    var pageObserver = new MutationObserver(function () {
      if (bind()) pageObserver.disconnect();
    });
    pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchTradeForm);
  } else {
    watchTradeForm();
  }
})();
